import { render } from "./MTeamLogin.vue?vue&type=template&id=b61483e2&scoped=true"
import script from "./MTeamLogin.vue?vue&type=script&lang=js"
export * from "./MTeamLogin.vue?vue&type=script&lang=js"

import "./MTeamLogin.vue?vue&type=style&index=0&id=b61483e2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61483e2"]])

export default __exports__